import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Menu, X, Play, Loader2, Instagram, Facebook, Music2, ChevronLeft, ChevronRight } from "lucide-react";
import SocialFeed from "@/components/SocialFeed";
import AutoFeeds from "@/components/AutoFeeds";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const WIX = "https://static.wixstatic.com/media";

// ===== Brand palette (matches wilson-contractors.co.uk) =====
// Navy panels: #1a1a5c   Red accent: #c41e3a   Wheat gold: #d4a017

// ===== Photos lifted from wilson-contractors.co.uk =====
const HERO_IMG = `${WIX}/4f7db2_2006d32fd1a8446581f10f551216b3e0f000.jpg/v1/fill/w_2400,h_700,al_c,q_85,enc_avif,quality_auto/4f7db2_2006d32fd1a8446581f10f551216b3e0f000.jpg`;
const ABOUT_IMG = `${WIX}/4f7db2_295adf9ffb4c4932ae2379e3526949ff~mv2.jpeg/v1/fill/w_1200,h_1100,fp_0.50_0.50,q_85,enc_avif,quality_auto/4f7db2_295adf9ffb4c4932ae2379e3526949ff~mv2.jpeg`;

const SERVICES = [
  { name: "SILAGE HARVESTING",     img: `${WIX}/4f7db2_425020bf711e4ae585f809fdae0aff5e~mv2.jpg/v1/fill/w_800,h_600,fp_0.50_0.50,q_85,enc_avif,quality_auto/4f7db2_425020bf711e4ae585f809fdae0aff5e~mv2.jpg` },
  { name: "SQUARE & ROUND BAILING", img: `${WIX}/4f7db2_68012610818e4ca3857c227b773e0c0c~mv2.jpeg/v1/fill/w_800,h_600,fp_0.50_0.50,q_85,enc_avif,quality_auto/4f7db2_68012610818e4ca3857c227b773e0c0c~mv2.jpeg` },
  { name: "ONE PASS SOWING",        img: `${WIX}/4f7db2_5a7a9cf25ead48a2a2e131bf4379e40d~mv2.jpg/v1/fill/w_800,h_600,fp_0.50_0.50,q_85,enc_avif,quality_auto/4f7db2_5a7a9cf25ead48a2a2e131bf4379e40d~mv2.jpg` },
  { name: "LIME SPREADING",         img: `${WIX}/4f7db2_f19acb31c1b0447282076fa967558c1f~mv2.jpg/v1/fill/w_800,h_600,fp_0.50_0.50,q_85,enc_avif,quality_auto/4f7db2_f19acb31c1b0447282076fa967558c1f~mv2.jpg` },
  { name: "PLOUGHING",              img: `${WIX}/4f7db2_180173f82acd423eafca125bd62e1195~mv2.jpg/v1/fill/w_800,h_600,fp_0.50_0.50,q_85,enc_avif,quality_auto/4f7db2_180173f82acd423eafca125bd62e1195~mv2.jpg` },
  { name: "MOWING",                 img: `${WIX}/4f7db2_86d9b57704e04cedab0312577998dc3f~mv2.jpg/v1/fill/w_800,h_600,fp_0.50_0.50,q_85,enc_avif,quality_auto/4f7db2_86d9b57704e04cedab0312577998dc3f~mv2.jpg` },
  { name: "MUCK SPREADING",         img: `${WIX}/4f7db2_02edeea6ea5342a9b7e6c129c7592840~mv2.jpg/v1/fill/w_800,h_600,fp_0.50_0.50,q_85,enc_avif,quality_auto/4f7db2_02edeea6ea5342a9b7e6c129c7592840~mv2.jpg` },
  { name: "CARTING",                img: `${WIX}/4f7db2_3662427560e441d591861b0100cd0297~mv2.jpg/v1/fill/w_800,h_600,fp_0.50_0.50,q_85,enc_avif,quality_auto/4f7db2_3662427560e441d591861b0100cd0297~mv2.jpg` },
  { name: "360 EXCAVATOR",          img: `${WIX}/4f7db2_8f03896a5df44dc08fc2f6f4893d6bb8~mv2.jpg/v1/fill/w_800,h_600,fp_0.50_0.50,q_85,enc_avif,quality_auto/4f7db2_8f03896a5df44dc08fc2f6f4893d6bb8~mv2.jpg` },
  { name: "DUMPER TRAILER",         img: `${WIX}/4f7db2_d086f3c34019484a93a511c5b345bbc9~mv2.jpg/v1/fill/w_800,h_600,fp_0.50_0.50,q_85,enc_avif,quality_auto/4f7db2_d086f3c34019484a93a511c5b345bbc9~mv2.jpg` },
  { name: "SNOW CLEARING",          img: `${WIX}/4f7db2_7ce6a87a102b4614be43c014f94275bf~mv2.jpg/v1/fill/w_800,h_600,fp_0.50_0.50,q_85,enc_avif,quality_auto/4f7db2_7ce6a87a102b4614be43c014f94275bf~mv2.jpg` },
];

const GALLERY = [
  "4f7db2_9161cdb734304fb4b626841b11b147fff003.jpg",
  "4f7db2_68012610818e4ca3857c227b773e0c0c~mv2.jpeg",
  "4f7db2_d01f36c2729746ff9503c1dd1e3ef5af~mv2.jpeg",
  "4f7db2_f9689a74bb064caeabc54d05b7cd73ef~mv2.jpeg",
  "4f7db2_58e650677afe46a0a05d29f6b0e3eeb5f003.jpg",
  "4f7db2_819fa02ce6eb4b61a8c7d52c8f83ca41~mv2.jpeg",
  "4f7db2_c2ead8d11e154d76b094aaa8943448e0~mv2.jpg",
  "4f7db2_425020bf711e4ae585f809fdae0aff5e~mv2.jpg",
  "4f7db2_d050fc9d653d4803821ead29b5bb3e4c~mv2.jpeg",
  "4f7db2_c56489d36741489b93275f5031d5a252~mv2.jpeg",
  "4f7db2_295adf9ffb4c4932ae2379e3526949ff~mv2.jpeg",
  "4f7db2_a11466f5e190474abcce594d297a6124~mv2.jpg",
  "4f7db2_f3131bd0653746d286580129768d5a72~mv2.jpeg",
  "4f7db2_f90e2a6dd1f94bc0bd217eca978447ed~mv2.jpeg",
  "4f7db2_71946ee732dc4386b855155b7579cfff~mv2.jpeg",
  "4f7db2_45858c4002994f17beb233d605bd93b9~mv2.jpg",
  "4f7db2_b12830976c7e4343909aeafb1a8625e7~mv2.jpeg",
  "4f7db2_ba10bd6e4e6a4cc78e62dcefbcf04bf2~mv2.jpeg",
  "4f7db2_bb1b8a2b485b4e91ac3781d877ec26a2~mv2.jpeg",
  "4f7db2_de5d601e18a14c3ea4dd5e94e6ee1835~mv2.jpeg",
  "4f7db2_2c0d8d2da7d9469f8bf5b74f5d8ac4b5~mv2.jpeg",
  "4f7db2_3ecbd43b18ee4b68a49acf941c92a846~mv2.jpeg",
  "4f7db2_cce26033c34b412e9f378ee5547ecd5f~mv2.jpeg",
  "4f7db2_9bdae14ff9b7488982b7e3dbebc65bce~mv2.jpeg",
  "4f7db2_45dfee5c73e5415eb810dad93506065b~mv2.jpeg",
].map(f => `${WIX}/${f}/v1/fit/w_900,h_700,q_85,enc_avif,quality_auto/${f}`);

const VIDEOS = [
  { id: "OAOKMKBGBR4", author: "Andy Wilson", duration: "03:04", title: "Wilson Contractors - Silage 2024 monymusk" },
  { id: "CBIbcZpg9e0", author: "GRASSMEN",    duration: "08:39", title: "GRASSFANS SPECIAL EPISODE" },
  { id: "j_SUVsyH5OI", author: "GRASSMEN",    duration: "03:23", title: "GRASSFANS - Chris Anderson and Wilson Contractors" },
  { id: "rUG2Bnpo8xI", author: "Andy Wilson", duration: "02:03", title: "Muck Spreading 2016" },
  { id: "BbvKezlQ9kA", author: "Andy Wilson", duration: "02:57", title: "Wilson Contractors 2015" },
  { id: "KFMzrF3g2g8", author: "Andy Wilson", duration: "04:10", title: "Square Bailing 2014" },
  { id: "uJWaskwVf_4", author: "Andy Wilson", duration: "02:59", title: "Wilson Contractors - Sowing 2014" },
];

// ===== Brand mark (official Wilson Contractors logo) =====
function BrandMark({ height = "h-12" }) {
  return (
    <a href="#top" className="flex items-center" data-testid="wilson-logo">
      <img src="/wilson-logo.png" alt="Wilson Contractors" className={`${height} w-auto`} />
    </a>
  );
}

// ===== Header =====
function Header({ open, setOpen }) {
  const links = [
    { href: "#about",    label: "About" },
    { href: "#services", label: "Services" },
    { href: "#gallery",  label: "Gallery" },
    { href: "#social",   label: "Social" },
    { href: "#videos",   label: "Videos" },
    { href: "#contact",  label: "Contact" },
  ];
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <BrandMark height="h-14" />
        <nav className="hidden md:flex items-center gap-6">
          {links.map(l => (
            <a key={l.href} href={l.href} data-testid={`nav-${l.label.toLowerCase()}`}
               className="text-[15px] font-medium text-slate-800 hover:text-[#c41e3a] transition-colors">{l.label}</a>
          ))}
          <div className="flex items-center gap-3 ml-2 pl-4 border-l border-slate-200">
            <a href="https://www.tiktok.com/@wilson.contractors" target="_blank" rel="noreferrer" aria-label="TikTok" className="text-slate-800 hover:text-[#c41e3a]"><Music2 size={18} /></a>
            <a href="https://www.facebook.com/wilsoncontractors.co.uk" target="_blank" rel="noreferrer" aria-label="Facebook" className="text-slate-800 hover:text-[#c41e3a]"><Facebook size={18} /></a>
            <a href="https://www.instagram.com/wilsoncontractors" target="_blank" rel="noreferrer" aria-label="Instagram" className="text-slate-800 hover:text-[#c41e3a]"><Instagram size={18} /></a>
          </div>
        </nav>
        <button onClick={() => setOpen(!open)} className="md:hidden text-slate-800 p-2" aria-label="menu" data-testid="mobile-menu-btn">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white px-6 py-4 space-y-3">
          {links.map(l => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)}
               className="block text-[15px] font-medium text-slate-800 hover:text-[#c41e3a] py-1">{l.label}</a>
          ))}
          <div className="flex items-center gap-4 pt-3 border-t border-slate-100">
            <a href="https://www.tiktok.com/@wilson.contractors" target="_blank" rel="noreferrer" aria-label="TikTok"><Music2 size={20} /></a>
            <a href="https://www.facebook.com/wilsoncontractors.co.uk" target="_blank" rel="noreferrer" aria-label="Facebook"><Facebook size={20} /></a>
            <a href="https://www.instagram.com/wilsoncontractors" target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram size={20} /></a>
          </div>
        </div>
      )}
    </header>
  );
}

// ===== Hero (clean banner image) =====
function Hero() {
  return (
    <section id="top" className="pt-20 bg-white">
      <div className="relative h-[35vh] md:h-[50vh] overflow-hidden bg-slate-100">
        <img src={HERO_IMG} alt="Wilson Contractors" className="absolute inset-0 w-full h-full object-cover" />
      </div>
    </section>
  );
}

// ===== About Us =====
function About() {
  return (
    <section id="about" className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 shadow-md">
          <div className="aspect-[4/3] md:aspect-auto overflow-hidden bg-slate-100">
            <img src={ABOUT_IMG} alt="Andy in the cab" className="w-full h-full object-cover" />
          </div>
          <div className="bg-[#1a1a5c] text-white px-8 md:px-12 py-12 md:py-16 flex flex-col justify-center text-center">
            <h2 className="font-display font-black text-3xl md:text-4xl tracking-wide mb-8 uppercase">About Us</h2>
            <div className="space-y-5 text-[15px] md:text-base text-white/95 leading-relaxed max-w-md mx-auto">
              <p>Wilson Contractors is a family owned and operated Agricultural Contracting business located near Sauchen, Aberdeenshire.</p>
              <p>We offer a wide range of services including Ploughing, Muck Spreading, Sowing &amp; Lime Spreading etc.</p>
              <p>Wilson Contractors specialise in Precision Farming &mdash; All machines are equipped with the Latest RTK GPS</p>
            </div>
            <div className="mt-10">
              <a href="#services" data-testid="cta-learn-more"
                 className="inline-block bg-slate-200 hover:bg-white text-slate-900 font-medium px-7 py-2.5 rounded-sm text-[15px] transition-colors">
                Learn More
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ===== Agricultural Services =====
function Services() {
  return (
    <section id="services" className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-display font-black text-3xl md:text-4xl tracking-wide uppercase" style={{ color: "#c41e3a" }}>
            Agricultural Services
          </h2>
          <p className="text-slate-700 text-base md:text-lg mt-2">What We Offer</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-0">
          {SERVICES.map((s, i) => (
            <article key={s.name} data-testid={`service-${i}`} className="group block">
              <div className="aspect-[4/3] overflow-hidden bg-slate-100">
                <img src={s.img} alt={s.name} loading="lazy"
                     className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="bg-[#1a1a5c] text-white text-center px-3 py-5 md:py-6">
                <h3 className="font-display font-bold text-sm md:text-[15px] tracking-wide uppercase">{s.name}</h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

// ===== Lightbox =====
function Lightbox({ images, index, onClose, onNav }) {
  useEffect(() => {
    if (index === null) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onNav(-1);
      if (e.key === "ArrowRight") onNav(1);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [index, onClose, onNav]);

  if (index === null) return null;
  return (
    <div data-testid="lightbox-overlay" onClick={onClose}
         className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 md:p-10 animate-in fade-in duration-200">
      <button onClick={onClose} aria-label="Close" data-testid="lightbox-close"
              className="absolute top-4 right-4 md:top-6 md:right-6 text-white/80 hover:text-white p-2 rounded-full hover:bg-white/10 transition-colors">
        <X size={28} />
      </button>
      <button onClick={(e) => { e.stopPropagation(); onNav(-1); }} aria-label="Previous image" data-testid="lightbox-prev"
              className="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 text-white/80 hover:text-white p-2 md:p-3 rounded-full hover:bg-white/10 transition-colors">
        <ChevronLeft size={32} />
      </button>
      <img src={images[index]} alt={`Wilson Contractors ${index + 1}`} data-testid="lightbox-image"
           onClick={(e) => e.stopPropagation()}
           className="max-w-full max-h-full object-contain select-none" />
      <button onClick={(e) => { e.stopPropagation(); onNav(1); }} aria-label="Next image" data-testid="lightbox-next"
              className="absolute right-2 md:right-6 top-1/2 -translate-y-1/2 text-white/80 hover:text-white p-2 md:p-3 rounded-full hover:bg-white/10 transition-colors">
        <ChevronRight size={32} />
      </button>
      <div className="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 text-white/60 text-xs font-mono tabular-nums">
        {index + 1} / {images.length}
      </div>
    </div>
  );
}

// ===== Gallery =====
function Gallery() {
  const [uploaded, setUploaded] = useState([]);
  const [lightboxIndex, setLightboxIndex] = useState(null);
  useEffect(() => {
    axios.get(`${API}/media`).then(r => setUploaded(r.data || [])).catch(() => {});
  }, []);
  const tiles = [...uploaded.map(u => u.url), ...GALLERY];
  const navigate = (dir) => setLightboxIndex((i) => (i + dir + tiles.length) % tiles.length);
  return (
    <section id="gallery" className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-display font-black text-3xl md:text-4xl tracking-wide uppercase" style={{ color: "#c41e3a" }}>Gallery</h2>
          <a href="https://www.instagram.com/wilsoncontractors" target="_blank" rel="noreferrer"
             className="inline-flex items-center gap-2 text-sm text-slate-700 hover:text-[#c41e3a] mt-2">
            <Instagram size={14} /> @wilsoncontractors
          </a>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-1 md:gap-2">
          {tiles.map((src, i) => (
            <button key={`${src}-${i}`} type="button" onClick={() => setLightboxIndex(i)}
                    data-testid={`gallery-tile-${i}`}
                    className="block aspect-square overflow-hidden bg-slate-100 group cursor-zoom-in">
              <img src={src} alt={`Wilson Contractors ${i + 1}`} loading="lazy"
                   className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </button>
          ))}
        </div>
      </div>
      <Lightbox images={tiles} index={lightboxIndex} onClose={() => setLightboxIndex(null)} onNav={navigate} />
    </section>
  );
}

// ===== Videos =====
function Videos() {
  return (
    <section id="videos" className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-display font-black text-3xl md:text-4xl tracking-wide uppercase text-center mb-12" style={{ color: "#c41e3a" }}>Videos</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {VIDEOS.map(v => (
            <a key={v.id} href={`https://www.youtube.com/watch?v=${v.id}`} target="_blank" rel="noreferrer" className="group block">
              <div className="relative aspect-video overflow-hidden bg-slate-900">
                <img src={`https://i.ytimg.com/vi/${v.id}/maxresdefault.jpg`} alt={v.title}
                     onError={(e) => { e.target.src = `https://i.ytimg.com/vi/${v.id}/hqdefault.jpg`; }}
                     className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-black/15 group-hover:bg-black/5 transition-colors" />
                <div className="absolute inset-0 grid place-items-center">
                  <div className="w-14 h-14 rounded-full bg-white/95 grid place-items-center shadow-lg group-hover:scale-110 transition-transform">
                    <Play size={20} className="text-slate-900 fill-current ml-0.5" />
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 bg-black/75 text-white text-[11px] px-2 py-0.5 font-mono tabular-nums">{v.duration}</span>
              </div>
              <div className="mt-3">
                <div className="text-[11px] uppercase tracking-widest text-slate-500">{v.author}</div>
                <h3 className="font-display font-bold text-[15px] text-slate-900 group-hover:text-[#c41e3a] transition-colors leading-snug mt-0.5">{v.title}</h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

// ===== Contact =====
function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const upd = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Thanks for submitting!");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch {
      toast.error("Couldn't send right now. Please try again or call us directly.");
    } finally { setBusy(false); }
  };
  return (
    <section id="contact" className="bg-white py-16 md:py-24">
      <div className="max-w-2xl mx-auto px-6">
        <h2 className="font-display font-black text-3xl md:text-4xl tracking-wide uppercase text-center mb-10" style={{ color: "#c41e3a" }}>Contact</h2>
        <form onSubmit={submit} className="space-y-5">
          <Field label="Name"    value={form.name}    onChange={upd("name")}    testid="contact-name" />
          <Field label="Email"   type="email" value={form.email} onChange={upd("email")} testid="contact-email" />
          <Field label="Subject" value={form.subject} onChange={upd("subject")} testid="contact-subject" />
          <Field label="Message" multiline value={form.message} onChange={upd("message")} testid="contact-message" />
          <div className="text-center pt-2">
            <button type="submit" disabled={busy} data-testid="contact-submit"
                    className="inline-flex items-center gap-2 bg-[#1a1a5c] hover:bg-[#272787] disabled:opacity-60 text-white font-medium px-10 py-2.5 rounded-sm transition-colors text-[15px]">
              {busy ? <><Loader2 size={14} className="animate-spin" /> Sending…</> : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}

function Field({ label, value, onChange, type = "text", multiline, testid }) {
  const common = "w-full bg-white border border-slate-300 focus:border-[#1a1a5c] outline-none px-3 py-2.5 text-[15px] text-slate-900 transition-colors";
  return (
    <label className="block">
      <span className="text-[13px] font-medium text-slate-800 mb-1.5 block">{label}</span>
      {multiline ? (
        <textarea required rows={5} value={value} onChange={onChange} data-testid={testid} className={`${common} resize-none`} />
      ) : (
        <input required type={type} value={value} onChange={onChange} data-testid={testid} className={common} />
      )}
    </label>
  );
}

// ===== Footer =====
function Footer() {
  return (
    <footer className="bg-white border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <BrandMark />
          <div className="flex items-center gap-4 text-slate-700">
            <a href="https://www.tiktok.com/@wilson.contractors" target="_blank" rel="noreferrer" aria-label="TikTok" className="hover:text-[#c41e3a]"><Music2 size={20} /></a>
            <a href="https://www.facebook.com/wilsoncontractors.co.uk" target="_blank" rel="noreferrer" aria-label="Facebook" className="hover:text-[#c41e3a]"><Facebook size={20} /></a>
            <a href="https://www.instagram.com/wilsoncontractors" target="_blank" rel="noreferrer" aria-label="Instagram" className="hover:text-[#c41e3a]"><Instagram size={20} /></a>
          </div>
        </div>
        <div className="mt-6 pt-6 border-t border-slate-100 flex flex-wrap items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Wilson Contractors. All rights reserved.</div>
          <Link to="/admin/login" className="text-slate-400 hover:text-slate-700 transition-colors" data-testid="admin-link">Staff sign-in</Link>
        </div>
      </div>
    </footer>
  );
}

// ===== Page =====
export default function Home() {
  const [open, setOpen] = useState(false);
  useEffect(() => { document.title = "Home | Wilson Contractors"; }, []);
  return (
    <div className="bg-white min-h-screen text-slate-900 font-body antialiased">
      <Header open={open} setOpen={setOpen} />
      <Hero />
      <About />
      <Services />
      <Gallery />
      <AutoFeeds />
      <SocialFeed />
      <Videos />
      <Contact />
      <Footer />
    </div>
  );
}
